import React from "react";

export default function ThankMax() {
  return <div>thankmax</div>;
}
